export default __webpack_public_path__ + "static/media/logo1.0847331a.svg";